<template>
    <v-container grid-list-xl>
        <cook :loading="loading" v-if="myCooks.cooks" :cooks="myCooks.cooks" v-on:deleteCook="deleteCook"/>

        <v-layout column>
            <v-flex xs12>
                <v-layout justify-center row>
                    <v-btn color="secondary" :disabled="!showMoreEnabled" @click="showMoreCooks">جلب المزيد</v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {
        MY_COOKS, DELETE_COOK
    } from '../../graphql/Cooks'
    import {
        mapGetters
    } from 'vuex'
    import Cook from '../Shared/Cook.vue'

    const pageSize = 9

    export default {
        name: 'MyCooks',
        data() {
            return {
                pageNum: 1,
                showMoreEnabled: true,
                myCooks: ''
            }
        },
        apollo: {
            myCooks: {
                query: MY_COOKS,
                variables: {
                    pageNum: 1,
                    pageSize
                }
            }
        },
        components: {
            'cook': Cook
        },
        computed: {
            ...mapGetters(['loading'])
        },
        methods: {
            deleteCook(cookId) {
                this.$store.dispatch('deleteCook', cookId)               
            },
            showMoreCooks() {
                this.pageNum += 1
                // fretch more data and transform original result
                this.$apollo.queries.myCooks.fetchMore({
                    variables: {
                        // pageNum incremented by 1
                        pageNum: this.pageNum,
                        pageSize
                    },
                    updateQuery: (prevResult, {
                        fetchMoreResult
                    }) => {

                        const newCooks = fetchMoreResult.myCooks.cooks
                        const hasMore = fetchMoreResult.myCooks.hasMore
                        this.showMoreEnabled = hasMore

                        return {
                            myCooks: {
                                __typename: prevResult.myCooks.__typename,
                                // merge previous cooks with new cooks
                                cooks: [
                                    ...prevResult.myCooks.cooks,
                                    ...newCooks
                                ],
                                hasMore
                            }
                        }
                    }
                })
            },
            goToCook(cookId) {
                this.$router.push(`/cooks/${cookId}`)
            }
        }
    }
</script>

<style scoped>
.cook-1 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
    font-family: 'Almarai', sans-serif !important; /* this was it */
}
</style>